// webapp/src/stores/checklist.js
import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class ChecklistStore extends LocalModel {
    constructor() {
        super('checklist', {
            namePlural: 'checklists',
            namePluralReal: 'checklists',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: { url: '/api/checklists/', params: { limit: 100, sort: '-createdDate' } },
                load: { url: '/api/checklists/', params: {} },
                save: { url: '/api/checklists/', params: {} },
                delete: { url: '/api/checklists/', params: {} },
            },
        });
    }

    @observable checklist = {};

    @observable checklists = [];

    @observable newChecklist = {};

    // Structural points update (add / remove / reorder / image change): replace the whole array.
    // Inline single-field edits of an existing point use editArrayObject (see edit component).
    @action
    async savePoints(id, points) {
        const response = await util.fetchApi('/api/checklists/' + id, { method: 'PATCH' }, { field: 'points', value: points });
        return response?.data;
    }

    // Assigned customers is a [Number] array; replace the whole array (whole-field PATCH).
    // Managed by a dedicated editor in the admin edit component (not a FormFieldsCompact field).
    @action
    async saveCustomers(id, customers) {
        const value = (customers || []).map(c => parseInt(c, 10)).filter(n => n > 0);
        const response = await util.fetchApi('/api/checklists/' + id, { method: 'PATCH' }, { field: 'customers', value });
        return response?.data;
    }

    @action
    async issue(id) {
        const response = await util.fetchApi('/api/checklists/' + id + '/issue', { method: 'POST' }, {});
        return response?.data;
    }
}

const checklistStore = new ChecklistStore();
export default checklistStore;
